import React from 'react';
import { Box } from '@mui/material';
import { presentationBackground } from '../theme/presentationBackground';

const AppBackground: React.FC = () => (
  <Box
    aria-hidden
    sx={{
      position: 'fixed',
      inset: 0,
      zIndex: 0,
      overflow: 'hidden',
      pointerEvents: 'none',
      bgcolor: presentationBackground.primary,
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        width: { xs: '85vmin', md: '58vmin' },
        height: { xs: '85vmin', md: '58vmin' },
        borderRadius: '50%',
        bgcolor: presentationBackground.circleLight,
        insetInlineStart: { xs: '-32vmin', md: '-18vmin' },
        top: { xs: '-22vmin', md: '-14vmin' },
      }}
    />
    <Box
      sx={{
        position: 'absolute',
        width: { xs: '95vmin', md: '72vmin' },
        height: { xs: '95vmin', md: '72vmin' },
        borderRadius: '50%',
        bgcolor: presentationBackground.circleTeal,
        insetInlineStart: { xs: '-42vmin', md: '-28vmin' },
        bottom: { xs: '-30vmin', md: '-22vmin' },
      }}
    />
  </Box>
);

export default AppBackground;
